(function() {
  "use strict";

  angular.module("PrintixInfoGroup", [])

    .constant("PrintixGroupInfoConstants", {
      SHOW: "group_info_show",
      HIDE: "group_info_hide"
    })

    .constant("PrintixGroupInfoSelectors", {
      MODAL_ID: "infoGroupModal",
      CONFIRM_BUTTON_CSS_CLASS: "confirm-button"
    })


    .controller("InfoGroupController", ["$rootScope", "$scope", "$location", "URLS", "PRINTER_STATUSES", "PrintixGroupInfoConstants",
      "PrintixGroupInfoSelectors",
      function($rootScope, $scope, $location, URLS, PRINTER_STATUSES, PrintixGroupInfoConstants,
        PrintixGroupInfoSelectors) {

        $scope.group = null;
        $scope.groupInfoModalId = PrintixGroupInfoSelectors.MODAL_ID;

        $scope.clearGroupInfo = function() {
          if ($scope.group) {
            $scope.group = null;
          }
        };

        var locationChangeListener = function(){};
        $scope.showGroupInfo = function(group) {
          if (group) {
            $scope.group = angular.copy(group);
            var groupModal = angular.element("#" + $scope.groupInfoModalId);
            groupModal.modal("show");
            locationChangeListener = $rootScope.$on('$locationChangeStart', function() {
              groupModal?.modal("hide");
            })
          } else {
            throw "$scope.showGroupInfo: group is missing";
          }
        };

        var SHOW_listener = $rootScope.$on(PrintixGroupInfoConstants.SHOW, function(name, group) {
          $scope.showGroupInfo(group);
        });

        $scope.$on("$destroy", function() {
          SHOW_listener();
          locationChangeListener();
        });
      }
    ])

    .directive("infoGroupObjectControl", ["$rootScope", "PrintixGroupInfoSelectors", "PrintixGroupInfoConstants",
      function($rootScope, PrintixGroupInfoSelectors, PrintixGroupInfoConstants) {
        return {
          link: function($scope, element, attrs) {
            element.on("hide.bs.modal", function() {
              $scope.clearGroupInfo(angular.element(document.activeElement).hasClass(PrintixGroupInfoSelectors.CONFIRM_BUTTON_CSS_CLASS));
            });
            var HIDE_listener = $rootScope.$on(PrintixGroupInfoConstants.HIDE, function() {
              element.modal("hide");
            });

            $scope.$on("$destroy", function() {
              HIDE_listener();
            });
          }
        };
      }
    ]);
})();
